import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";


export const procedureDiagramFields = `
id
diagramUniqueId
procedureDiagram
`


export const CREATE_PROCEDURE_DIAGRAM = gql`
  mutation CreateProcedureDiagramMutation($input: ServiceProcedureDiagramInputObjects!) {
    createProcedureDiagramMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${procedureDiagramFields}
      }
    }
  }
`


export const GET_PROCEDURE_DIAGRAM = gql`
  query GetInstitutionServicesDeliveryProcedureDiagram($serviceUniqueId: String) {
    getInstitutionServicesDeliveryProcedureDiagram(serviceUniqueId: $serviceUniqueId) {
      ${baseResponseGraphqlField}
      data {
        ${procedureDiagramFields}
      }
    }
  }
`


